import {
    Component,
    Output,
    Input,
    EventEmitter,
    OnChanges,
    AfterViewInit,
    SimpleChange,
    ChangeDetectionStrategy,
    NgZone,
    ElementRef,
    ViewChild,
    Renderer
} from '@angular/core';
import { InventoryTreeHolder } from '../tree-holder/inventory-tree-holder.component';
import { TreeService, TreeNode } from '../../../../../common/tree';

@Component({
    selector: 'tree-vcd',
    template: `
       <div>
        <inventory-tree-holder #treeview [url]="url" [state]="state"
        [actionsMap]="menuActionMapping"
        [computeTreeVisible]="computeTreeVisible"
        [linksMap]="menuLinksMapping" autofocus
        [(forceReloadTree)]="forceReloadTree"></inventory-tree-holder>
      </div>
    `
})
export class InventoryTreeVCD implements AfterViewInit {
    @Input() state: any;
    @Input() forceReloadTree: any;
    @Input() computeTreeVisible: boolean;
    show: boolean = true;
    @Output() onShow = new EventEmitter();
    @ViewChild('treeview') treeView: InventoryTreeHolder;
    menuActionMapping: any;
    menuLinksMapping: any;
    url: String;
    constructor(private element: ElementRef,
                private renderer: Renderer, private ngZone: NgZone) {
        this.show = true;
        this.url = '/hybridity/api/vcd/inventory/query?entityType=org';
        this.menuActionMapping = {
            'Edit Organization':
                (tree: TreeService, node: TreeNode) => { alert('Edit Organization'); },
            'Delete Organization':
                (tree: TreeService, node: TreeNode) => { alert('Delete Organization'); },
            'Edit Virtual Datacenter':
                (tree: TreeService, node: TreeNode) => { alert('Edit Virtual Datacenter'); },
            'Delete Virtual Datacenter':
                (tree: TreeService, node: TreeNode) => { alert('Delete Virtual Datacenter'); }
        };
        this.menuLinksMapping = {
            'ORG': [
                { title: 'Edit Organization' },
                { title: 'Delete Organization' }
            ],
            'VDC': [
                { title: 'Edit Virtual Datacenter' },
                { title: 'Delete Virtual Datacenter' }
            ]
        };
    }
    
    ngOnInit() {
        this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
    }

    ngAfterViewInit() {
        // TODO Find the first root node and preselect
    }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        // TODO - Capture state changes and set child components
    }

    toggleState() {
        this.show = !this.show;
        if (this.show) {
            this.onShow.emit(this.show);
            this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory-tree/vcd/inventory-tree-vcd.component.ts